var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClinkFiliale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_326",
    "data-name": "Raggruppa 326",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.009,
    height: 60.205,
    viewBox: "0 0 56.009 60.205",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_277",
    "data-name": "Rettangolo 277",
    width: 56.009,
    height: 60.205,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_318",
    "data-name": "Raggruppa 318",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1062",
    "data-name": "Tracciato 1062",
    d: "M40.376,69.108c-7.628,0-13.6-11.494-13.6-26.167s5.975-26.167,13.6-26.167a.939.939,0,0,1,0,1.877c-6.356,0-11.725,11.124-11.725,24.29S34.02,67.231,40.376,67.231,52.1,56.108,52.1,42.942a.939.939,0,1,1,1.877,0c0,14.673-5.975,26.167-13.6,26.167",
    transform: "translate(-14.21 -8.903)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1063",
    "data-name": "Tracciato 1063",
    d: "M26.167,69.109a26.167,26.167,0,0,1,0-52.333.939.939,0,0,1,.939.939v49.5A24.318,24.318,0,0,0,50.456,42.943a.939.939,0,0,1,1.877,0A26.2,26.2,0,0,1,26.167,69.109m-.939-50.438a24.29,24.29,0,0,0,0,48.543Z",
    transform: "translate(0 -8.904)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_275",
    "data-name": "Rettangolo 275",
    width: 23.863,
    height: 1.877,
    transform: "translate(2.303 24.691)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_276",
    "data-name": "Rettangolo 276",
    width: 47.727,
    height: 1.877,
    transform: "translate(2.303 41.51)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1064",
    "data-name": "Tracciato 1064",
    d: "M77.6.014A12.717,12.717,0,0,0,65.587,11.986,12.57,12.57,0,0,0,69.555,21.8l8.064,8.064a.775.775,0,0,0,1.092.009c1.835-1.794,7.69-7.529,8.332-8.271A12.616,12.616,0,0,0,77.6.014m1.692,18.145a5.644,5.644,0,1,1,4.431-4.431,5.65,5.65,0,0,1-4.431,4.431",
    transform: "translate(-34.801 0)",
    fill: "#dd2027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1065",
    "data-name": "Tracciato 1065",
    d: "M90.353,72.413H74.344a.939.939,0,0,1,0-1.877h16.01a.939.939,0,0,1,0,1.877",
    transform: "translate(-38.958 -37.436)",
    fill: "#dd2027"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinkFiliale);
export default __webpack_public_path__ + "static/media/clink_filiale.84a132dae20bf2cb8e91da5b49b656ab.svg";
export { ForwardRef as ReactComponent };